var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.21875 0.5625C4.40625 0.208333 4.70833 0.0208333 5.125 0H8.875C9.29167 0.0208333 9.59375 0.208333 9.78125 0.5625L10 1H13C13.2917 1 13.5312 1.09375 13.7188 1.28125C13.9062 1.46875 14 1.70833 14 2C14 2.29167 13.9062 2.53125 13.7188 2.71875C13.5312 2.90625 13.2917 3 13 3H1C0.708333 3 0.46875 2.90625 0.28125 2.71875C0.09375 2.53125 0 2.29167 0 2C0 1.70833 0.09375 1.46875 0.28125 1.28125C0.46875 1.09375 0.708333 1 1 1H4L4.21875 0.5625ZM13 4L12.3438 14.5938C12.3021 14.9896 12.1458 15.3229 11.875 15.5938C11.5833 15.8646 11.2396 16 10.8438 16H3.15625C2.76042 16 2.41667 15.8646 2.125 15.5938C1.85417 15.3229 1.69792 14.9896 1.65625 14.5938L1 4H13Z",
    fill: "#0F99D6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.825bfad0.svg";
export { ForwardRef as ReactComponent };